export var MergeState;
(function (MergeState) {
    MergeState["MERGE_STATE_MERGED"] = "MERGED";
    MergeState["MERGE_STATE_PENDING"] = "PENDING";
    MergeState["MERGE_STATE_CONFLICT"] = "CONFLICT";
    MergeState["MERGE_STATE_FAILED"] = "FAILED";
})(MergeState || (MergeState = {}));
